import { Customer, defaultCustomer } from "../Customer/Customer";

export interface Metadata {
  id: string;
  name: string;
  x509Cert: string;
  entityId: string;
  ssoLogOutBinding: string;
  ssoLogOutURL: string;
  ssoURL: string;
  customerid: string;
  customer: Customer;
  jitEnabled: boolean;
}

export interface MetadataFormValues {
  id: string;
  name: string;
  x509Cert: string;
  entityId: string;
  ssoLogOutBinding: string;
  ssoLogOutURL: string;
  ssoURL: string;
  customerid: string;
  customer: Customer;
  jitEnabled: JitOptionType;
}

export const JIT_OPTIONS: JitOptionType[] = [
  { value: true, label: "On" },
  { value: false, label: "Off" },
];

interface JitOptionType {
  value: boolean;
  label: string;
}

export const defaultMetaData: Metadata = {
  id: "",
  name: "",
  x509Cert: "",
  entityId: "",
  ssoLogOutBinding: "",
  ssoLogOutURL: "",
  ssoURL: "",
  customerid: "",
  customer: defaultCustomer,
  jitEnabled: false,
};
